"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return (vue_2.pushScopeId("data-v-1333615b"), n = n(), vue_2.popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "reference"
};
var _hoisted_2 = { class: "reference-box" };
var _hoisted_3 = { class: "reference-box-show" };
var _hoisted_4 = { class: "reference-box-show-name" };
var _hoisted_5 = {
    key: 1,
    class: "reply"
};
var _hoisted_6 = { class: "reply-box" };
var _hoisted_7 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_2.createElementVNode("i", null, null, -1); });
var _hoisted_8 = { class: "reply-box-show" };
var vue_3 = require("vue");
exports.default = vue_1.defineComponent({
    __name: 'message-input-reference-or-reply',
    props: {
        replyOrReference: {
            type: Object,
            default: function () { return ({}); },
        },
        isH5: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['resetReplyOrReference'],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var _b = vue_3.toRefs(props), replyOrReference = _b.replyOrReference, isH5 = _b.isH5;
        var close = function () {
            emit('resetReplyOrReference');
        };
        return function (_ctx, _cache) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
            return ((_a = vue_2.unref(replyOrReference)) === null || _a === void 0 ? void 0 : _a.show)
                ? (vue_2.openBlock(), vue_2.createElementBlock("div", {
                    key: 0,
                    class: vue_2.normalizeClass([
                        ((_b = vue_2.unref(replyOrReference)) === null || _b === void 0 ? void 0 : _b.show) === 'reference' && 'message-input-reference',
                        ((_c = vue_2.unref(replyOrReference)) === null || _c === void 0 ? void 0 : _c.show) === 'reply' && 'message-input-reply',
                        vue_2.unref(isH5) && ((_d = vue_2.unref(replyOrReference)) === null || _d === void 0 ? void 0 : _d.show) === 'reference' && 'message-input-reference-h5',
                        vue_2.unref(isH5) && ((_e = vue_2.unref(replyOrReference)) === null || _e === void 0 ? void 0 : _e.show) === 'reply' && 'message-input-reply-h5',
                    ])
                }, [
                    (((_f = vue_2.unref(replyOrReference)) === null || _f === void 0 ? void 0 : _f.show) === 'reference')
                        ? (vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_1, [
                            vue_2.createElementVNode("div", _hoisted_2, [
                                vue_2.createElementVNode("div", _hoisted_3, [
                                    vue_2.createElementVNode("span", _hoisted_4, vue_2.toDisplayString(((_h = (_g = vue_2.unref(replyOrReference)) === null || _g === void 0 ? void 0 : _g.message) === null || _h === void 0 ? void 0 : _h.nick) ? (_k = (_j = vue_2.unref(replyOrReference)) === null || _j === void 0 ? void 0 : _j.message) === null || _k === void 0 ? void 0 : _k.nick : (_m = (_l = vue_2.unref(replyOrReference)) === null || _l === void 0 ? void 0 : _l.message) === null || _m === void 0 ? void 0 : _m.from) + ": ", 1),
                                    vue_2.createElementVNode("span", null, vue_2.toDisplayString((_o = vue_2.unref(replyOrReference)) === null || _o === void 0 ? void 0 : _o.content), 1)
                                ]),
                                vue_2.createElementVNode("label", {
                                    class: "icon icon-cancel",
                                    onClick: close
                                })
                            ])
                        ]))
                        : (((_p = vue_2.unref(replyOrReference)) === null || _p === void 0 ? void 0 : _p.show) === 'reply')
                            ? (vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_5, [
                                vue_2.createElementVNode("div", _hoisted_6, [
                                    _hoisted_7,
                                    vue_2.createElementVNode("div", _hoisted_8, [
                                        vue_2.createElementVNode("span", null, vue_2.toDisplayString(((_r = (_q = vue_2.unref(replyOrReference)) === null || _q === void 0 ? void 0 : _q.message) === null || _r === void 0 ? void 0 : _r.nick) ? (_t = (_s = vue_2.unref(replyOrReference)) === null || _s === void 0 ? void 0 : _s.message) === null || _t === void 0 ? void 0 : _t.nick : (_v = (_u = vue_2.unref(replyOrReference)) === null || _u === void 0 ? void 0 : _u.message) === null || _v === void 0 ? void 0 : _v.from) + vue_2.toDisplayString(vue_2.unref(isH5) ? ':' : ''), 1),
                                        vue_2.createElementVNode("span", null, vue_2.toDisplayString((_w = vue_2.unref(replyOrReference)) === null || _w === void 0 ? void 0 : _w.content), 1)
                                    ]),
                                    vue_2.createElementVNode("label", {
                                        class: "icon icon-cancel",
                                        onClick: close
                                    })
                                ])
                            ]))
                            : vue_2.createCommentVNode("", true)
                ], 2))
                : vue_2.createCommentVNode("", true);
        };
    }
});
